import { useCreditsState } from '@atlassian/rovo-credits/credits-provider';

import { expValEquals } from '@confluence/feature-experiments';

/**
 * True only in the `confluence_ubp_ai_credits` treatment, when the nearest `CreditsProvider`
 * reports that depleted credits block AI actions.
 */
export const useIsOutOfRovoCredits = (): boolean => {
	const { bannerState } = useCreditsState();

	return (
		bannerState?.balanceState === 'depleted' &&
		bannerState.depletionBehavior === 'block' &&
		expValEquals('confluence_ubp_ai_credits', 'isEnabled', true)
	);
};
